export const SHIFT = {
  office: { label: "Office", cls: "bg-teal-50 border-teal-300 text-teal-900", dot: "bg-teal-600" },
  remote: { label: "Remote", cls: "bg-indigo-50 border-indigo-300 text-indigo-900", dot: "bg-indigo-500" },
};

export const ROSTER_STATUS = {
  new: { label: "Not started", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  draft: { label: "Draft", cls: "bg-amber-50 text-amber-800 border-amber-300 border-dashed" },
  submitted: { label: "Submitted", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  changed: { label: "Changed by supervisor", cls: "bg-orange-50 text-orange-800 border-orange-300" },
};

export const PRIORITY = {
  high: { label: "High", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
  medium: { label: "Medium", cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  low: { label: "Low", cls: "bg-slate-50 text-slate-600 border-slate-200", dot: "bg-slate-400" },
};

export const TASK_STATUS = {
  todo: { label: "To do", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  in_progress: { label: "In progress", cls: "bg-blue-50 text-blue-800 border-blue-200" },
  done: { label: "Done", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
};

export const HOLIDAY = {
  annual: { label: "Annual leave", cls: "bg-rose-100 text-rose-900 border-rose-300" },
  sick: { label: "Sick leave", cls: "bg-red-100 text-red-900 border-red-300" },
  other: { label: "Other leave", cls: "bg-purple-100 text-purple-900 border-purple-300" },
};

export const HOLIDAY_STATUS = {
  pending: { label: "Pending", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  approved: { label: "Approved", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  declined: { label: "Declined", cls: "bg-rose-50 text-rose-700 border-rose-300" },
};

export const can = (u, ...perms) => !!u && perms.some((p) => (u.permissions || []).includes(p));

export const initials = (name = "") => name.replace(/[^\p{L}\s]/gu, "").split(/\s+/).filter(Boolean).map((p) => p[0]).slice(0, 2).join("").toUpperCase();
